module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_outside_01.929425bb.png";